import { useContext } from 'react';
import { IgdChartsDataContext } from '../contexts/IgdChartsDataContext';

export const useIgdChartsDataContext = () => {
    return useContext(IgdChartsDataContext);
};
